import { request } from "./index.js";
import { apiHost, newPlatform, oldPlatform } from "./config.js";

export default {

  // 往来单位类型
  contactTypes() {
    return request({
      url: `${apiHost}/travelExpensesReimbursement/contactTypes`,
      method: "get",
    });
  },

  // 发票类型
  getDropList() {
    return request({
      url: `${apiHost}/invoice/dropList`,
      method: "get",
    });
  },
  // 新增借款审批单
  addLoan(data) {
    return request({
      url: `${apiHost}/loanApproval/add`,
      method: "post",
      data,
    });
  },
  // 修改借款审批单
  editLoan(data) {
    return request({
      url: `${apiHost}/loanApproval/update`,
      method: "post",
      data,
    });
  },

  // 审批流套件
  getApproveModelId(data) {
    return request({
      url: `${apiHost}/approvalProcess/getKitId`,
      method: "post",
      data,
    });
  },
  approvalProcess(data) {
    return request({
      url: `${apiHost}/approvalProcess/save`,
      method: "post",
      data,
    });
  },
  // 借款审批单详情
  getLoanInfo(id) {
    return request({
      url: `${apiHost}/loanApproval/detail/${id}`,
      method: "get",
    });
  },
  // 新增费用报销单
  addCost(data) {
    return request({
      url: `${apiHost}/expense/reimbursement/add`,
      method: "post",
      data,
    });
  },
  // 修改费用报销单
  editCost(data) {
    return request({
      url: `${apiHost}/expense/reimbursement/update`,
      method: "post",
      data,
    });
  },

  // 费用报销单详情
  getCostInfo(id) {
    return request({
      url: `${apiHost}/expense/reimbursement/info?id=${id}`,
      method: "get",
    });
  },
  // 新增付款申请单
  addPaymentApplication(data) {
    return request({
      url: `${apiHost}/payment/application/add`,
      method: "post",
      data,
    });
  },
  // 修改付款申请单
  editPaymentApplication(data) {
    return request({
      url: `${apiHost}/payment/application/update`,
      method: "post",
      data,
    });
  },

  // 付款申请单详情
  applicationInfo(id) {
    return request({
      url: `${apiHost}/payment/application/info?id=${id}`,
      method: "get",
    });
  },
  // 新增差旅报销单
  addtravelExpenses(data) {
    return request({
      url: `${apiHost}/travelExpensesReimbursement/add`,
      method: "post",
      data,
    });
  },
  // 修改差旅报销单
  editTravelExpenses(data) {
    return request({
      url: `${apiHost}/travelExpensesReimbursement/edit`,
      method: "post",
      data,
    });
  },
  // 差旅详情
  travelExpensesReimbursementDetail(id) {
    return request({
      url: `${apiHost}/travelExpensesReimbursement/detail?id=${id}`,
      method: "get",
    });
  },
  // 领款单新增
  addReceive(data) {
    return request({
      url: `${apiHost}/draw/add`,
      method: "post",
      data,
    });
  },
  // 领款单修改
  editReceive(data) {
    return request({
      url: `${apiHost}/draw/edit`,
      method: "post",
      data,
    });
  },
  // 领款单详情
  receiveDetail(id) {
    return request({
      url: `${apiHost}/draw/detail?id=${id}`,
      method: "get",
    });
  },

  getSign(data) {
    return request({
      url: `${apiHost}/file/uploadUrl`,
      method: "post",
      data,
    });
  },
  relevanceLoan(data) {
    return request({
      url: `${apiHost}/loanApproval/listForTravel`,
      method: "post",
      data,
    });
  },
  // 获取用户信息
  getUserInfo() {
    return request({
      url: `${newPlatform}/system/user/info`,
      method: "get",
    });
  },
  getApproveurls(data) {
    return request({
      url: `${oldPlatform}/res/urls`,
      method: 'post',
      data,
    });
  },
  // 当前登录人的职员信息
  getStaffDetails() {
    return request({
      url: `${newPlatform}/system/staff/current`,
      method: "get",
    });
  },

  // 数据中心供应商
  getSupplierList(data) {
    return request({
      url: `${newPlatform}/basic/supplier/page`,
      method: 'post',
      data,
    });
  },

  // 数据中心客户
  getCustomerList(data) {
    return request({
      url: `${newPlatform}/basic/customer/page`,
      method: 'post',
      data,
    });
  },

  // 数据中心员工
  getStaffList(data) {
    return request({
      url: `${newPlatform}/system/staff/page`,
      method: 'post',
      data,
    });
  },

  // 数据中心部门
  getDeptfList(data) {
    return request({
      url: `${newPlatform}/system/dept/page`,
      method: 'post',
      data,
    });
  },

  // 获取关联审批单
  approvalOldList(data) {
    return request({
      url: `${apiHost}/billRelate/getApprovalList`,
      method: 'post',
      data,
    });
  },

  // 获取关联审批单参数集合
  approvalOldListIds(data) {
    return request({
      url: `${apiHost}/billRelate/listAll`,
      method: 'post',
      data,
    });
  },

  // 新版供应商获取详情
  getSupplier(data) {
    return request({
      url: `${newPlatform}/basic/supplier/${data}`,
      method: 'get',
      data
    });
  },

  // 新版客户获取详情
  getCustomer(data) {
    return request({
      url: `${newPlatform}/basic/customer/${data}`,
      method: 'get',
      data
    });
  },

  // 新版员工获取详情
  getStaff(data) {
    return request({
      url: `${newPlatform}/system/staff/${data}`,
      method: 'get',
      data
    });
  },
  // 数据中心获取其他往来单位
  getRelatedCompany(data) {
    return request({
      url: `${newPlatform}/basic/related-company/page`,
      method: 'post',
      data
    });
  },
  // 往来单位获取详情
  getRelatedCompanyDetails(data) {
    return request({
      url: `${newPlatform}/basic/related-company/${data}`,
      method: 'get',
      data
    });
  },
  // 过滤公司项目接口
  queryCompanyProjectList(data) {
    return request({
      // url: `${oldPlatform}/project/main/queryProjectList?companyId=${data.companyId}&projectName=${data.projectName}&projectApprovalStatus=${data.projectApprovalStatus}`,
      url: `${newPlatform}/project/project/main/getProjectApprovalAndUserIdList?userId=${data.userId}`,
      method: 'get',
    });
  },

  // 兼容大亚湾项目
  queryProjectNameStatus(data) {
    return request({
      url: `${apiHost}/projectName/showOrNot`,
      method: 'get',
      data
    });
  },

  // 数据中心币种
  getCdcCurrency(data) {
    return request({
      url: `${newPlatform}/basic/currency/page`,
      method: 'post',
      data
    });
  }
};

